export class Bonus {
    constructor(scene) {
        this.scene = scene;
        this.enemies = undefined;
        this.explodeContainer = this.scene.add.container();
        this.bonusContainer = this.scene.add.container();
        this.bonusContainer.add(this.explodeContainer);
        this.bonusContainer.setScale(.8);
        this.groundY = this.scene.slots.frame.height + 100;
        this.addViking();
        this.callback = undefined;

        this.hornSound = this.scene.sound.add('horn');
        this.battleCrySound = this.scene.sound.add('battlecry', {"rate":1.2});
        this.marchingSound = this.scene.sound.add('marching', {"rate":2});
        this.runningSound = this.scene.sound.add('marching', {"rate":3});
    }

    init(callback) {
        this.callback = callback;

        if(this.scene.slots.spinStarted) {
            return;
        }

        this.tweenInEnemy();
    }

    addViking() {
        this.viking = this.scene.add.sprite(0, 0, 'top_viking').setOrigin(0.5, 0.5);
        this.viking.x = -380;
        this.viking.y = 120 + this.scene.slots.frameTopOffset;
        this.viking.originalX = this.viking.x;
        this.viking.originalY = this.viking.y;

        this.bonusContainer.add(this.viking);
    }

    tweenInEnemy() {
        this.hornSound.play();
        this.enemies = this.scene.add.sprite(0, this.groundY, 'enemy_runin').setOrigin(0.5, 0.5);
        this.bonusContainer.add(this.enemies);
        this.enemies.x = this.scene.sys.game.canvas.width + this.enemies.width / 2;

        var config = {
            key: 'enemy_runin',
            frames: this.scene.anims.generateFrameNumbers('enemy_runin',
            {
                start: 0,
                end: 6,
            }),
            frameRate: 10,
            yoyo: false,
            repeat: -1,
            delay: 100
        };
    
        this.scene.anims.create(config);
        this.enemies.anims.load('enemy_runin');
        this.enemies.setFrame(0);
        this.enemies.anims.play('enemy_runin');
        this.marchingSound.play();
        this.enemies.once(Phaser.Animations.Events.ANIMATION_STOP, () => {
                this.playEnemyStopAnimation();
            }
        );
    
        this.enemies.tween = this.scene.add.tween({
            targets: this.enemies,
            x: this.scene.slots.frame.x + this.scene.slots.frame.width / 2,
            ease: 'Power0',
            duration: 2000,
            yoyo: 0,
            repeat: 0,
            onComplete: () => {
                this.enemies.anims.stop(0);
            },
        });
    }

    playEnemyStopAnimation() {
        var config = {
            key: 'enemy_stop',
            frames: this.scene.anims.generateFrameNumbers('enemy_stop',
            {
                start: 0,
                end: 9,
            }),
            frameRate: 15,
            yoyo: false,
            repeat: 0,
        };
    
        this.scene.anims.create(config);
        this.enemies.anims.load('enemy_stop');
        this.enemies.setFrame(6);
        this.marchingSound.stop();
        this.enemies.anims.play('enemy_stop');

        this.enemies.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                this.vikingFallDown();
            }
        );
    }

    vikingFallDown() {
        let sprite = this.scene.add.sprite(this.viking.x, this.viking.y + this.viking.height / 2, 'flash').setOrigin(0.5, 0.5);
        sprite.alpha = 0;
        sprite.setScale(0);
        this.bonusContainer.add(sprite);

        this.scene.sound.play('spark');

        this.viking.tween = this.scene.add.tween({
            targets: sprite,
            scale: 1,
            alpha: 1,
            ease: 'Power0',
            duration: 200,
            yoyo: 1,
            repeat: 0,
            delay: 0,
            onComplete: () => {
                this.viking.setTexture('viking_falling');

                this.battleCrySound.play();
                
                this.viking.tween = this.scene.add.tween({
                    targets: this.viking,
                    y: this.groundY,
                    x: this.viking.x - 200,
                    ease: 'Power0',
                    duration: 800,
                    yoyo: 0,
                    repeat: 0,
                    delay: 50,
                    onComplete: () => {
                        this.battleCrySound.stop();
                        this.scene.cameras.main.shake(200);
                        this.vikingLand();
                    },
                })
            },
        })
    }

    vikingLand() {
        var config = {
            key: 'viking_land',
            frames: this.scene.anims.generateFrameNumbers('viking_land',
            {
                start: 0,
                end: 1,
            }),
            frameRate: 10,
            yoyo: false,
            repeat: 0,
        };
    
        this.scene.anims.create(config);
        this.scene.sound.play('impact');
        this.viking.anims.load('viking_land');
        this.viking.anims.play('viking_land');

        this.viking_landing_dust = this.scene.add.sprite(this.viking.x, this.viking.y + this.viking.height / 2, 'viking_landing_dust').setOrigin(0.5, 0.5);
        this.bonusContainer.add(this.viking_landing_dust);

        var config = {
            key: 'viking_landing_dust',
            frames: this.scene.anims.generateFrameNumbers('viking_landing_dust',
            {
                start: 0,
                end: 7,
            }),
            frameRate: 10,
            yoyo: 0,
            repeat: 0,
        };
    
        this.scene.anims.create(config);
        this.viking_landing_dust.anims.load('viking_landing_dust');
        this.viking_landing_dust.anims.play('viking_landing_dust');

        this.viking_landing_dust.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                this.viking_landing_dust.destroy();
                this.vikingChargeUp();
            }
        );
    }

    vikingChargeUp() {
        var config = {
            key: 'viking_charge_up',
            frames: this.scene.anims.generateFrameNumbers('viking_charge_up',
            {
                start: 0,
                end: 2,
            }),
            frameRate: 10,
            yoyo: 0,
            repeat: 0,
        };
    
        this.scene.anims.create(config);
        this.viking.anims.load('viking_charge_up');
        this.viking.anims.play('viking_charge_up');

        this.viking.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                this.vikingRun();
            }
        );
    }

    vikingRun() {
        var config = {
            key: 'viking_run',
            frames: this.scene.anims.generateFrameNumbers('viking_run',
            {
                start: 0,
                end: 6,
            }),
            frameRate: 10,
            yoyo: false,
            repeat: -1,
        };
    
        this.scene.anims.create(config);
        this.viking.anims.load('viking_run');
        this.viking.anims.play('viking_run');
        this.runningSound.play();

        this.viking.tween = this.scene.add.tween({
            targets: this.viking,
            x: this.enemies.x,
            ease: 'Power0',
            duration: 600,
            yoyo: 0,
            repeat: 0,
            onComplete: () => {
                this.scene.cameras.main.shake(300);
                this.scene.sound.play('collision');
                this.viking.tween = this.scene.add.tween({
                    targets: this.viking,
                    x: this.scene.sys.game.canvas.width + this.viking.width,
                    ease: 'Power0',
                    duration: 600,
                    yoyo: 0,
                    repeat: 0,
                    onComplete: () => {
                        this.runningSound.stop();
                        this.viking.anims.stop();
                        this.playBonusText();
                    },
                });

                this.enemiesExplode();
            },
        })
    }

    enemiesExplode() {
        this.addExplodionGroup();
        const enemiesWidth = this.enemies.width;
        this.enemies.destroy();

        for(const [symbolIndex, sprite] of Object.entries(this.explodeContainer.getAll())) {
            let y = Phaser.Math.Between(sprite.y - 400, sprite.y);
            let angle = Phaser.Math.Between(10, 220);
            let duration = Phaser.Math.Between(700, 1000);

            sprite.tween = this.scene.add.tween({
                targets: sprite,
                x: this.scene.sys.game.canvas.width + enemiesWidth,
                y: y,
                angle: angle,
                ease: 'Power0',
                duration: duration,
                yoyo: 0,
                repeat: 0,
            });
        }
    }

    reset() {
        for(const [symbolIndex, sprite] of Object.entries(this.explodeContainer.getAll())) {
            if(sprite.tween && sprite.tween.isPlaying()) {
                sprite.tween.remove();
            }

            sprite.destroy();
        }

        for(const [symbolIndex, sprite] of Object.entries(this.bonusContainer.getAll())) {
            if(sprite.type !== 'Container') {
                if(sprite.tween && sprite.tween.isPlaying()) {
                    sprite.tween.remove();
                }
    
                if(sprite.anims) {
                    if(sprite.anims.isPlaying) {
                        sprite.anims.pause();
                    }
                }

                sprite.alpha = 0;
            }
        }
        
        this.hornSound.stop();
        this.battleCrySound.stop();
        this.marchingSound.stop();
        this.runningSound.stop();

        this.addViking();
        this.explodeContainer.removeAll();

        this.doCallback();
    }

    addExplodionGroup() {
        this.enemy_impact_dust_front = this.scene.add.sprite(this.enemies.x, this.enemies.y, 'enemy_impact_dust_front').setOrigin(0.5, 0.5);
        this.bonusContainer.add(this.enemy_impact_dust_front);

        var config = {
            key: 'enemy_impact_dust_front',
            frames: this.scene.anims.generateFrameNumbers('enemy_impact_dust_front',
            {
                start: 0,
                end: 9,
            }),
            frameRate: 10,
            yoyo: false,
            repeat: 0
        };
    
        this.scene.anims.create(config);
        this.enemy_impact_dust_front.anims.load('enemy_impact_dust_front');

        let sprite = this.scene.add.sprite(935, 500, 'falling_shield_06').setOrigin(0.5, 0.5);
        this.explodeContainer.add(sprite);

        sprite = this.scene.add.sprite(920, 580, 'enemy_falling_02').setOrigin(0.5, 0.5);
        this.explodeContainer.add(sprite);

        sprite = this.scene.add.sprite(1050, 600, 'enemy_falling_01').setOrigin(0.5, 0.5);
        this.explodeContainer.add(sprite);

        sprite = this.scene.add.sprite(1160, 575, 'enemy_falling_03').setOrigin(0.5, 0.5);
        this.explodeContainer.add(sprite);

        sprite = this.scene.add.sprite(1225, 540, 'falling_shield_05').setOrigin(0.5, 0.5);
        this.explodeContainer.add(sprite);

        sprite = this.scene.add.sprite(1090, 660, 'falling_shield_04').setOrigin(0.5, 0.5);
        this.explodeContainer.add(sprite);

        sprite = this.scene.add.sprite(1070, 555, 'falling_shield_03').setOrigin(0.5, 0.5);
        this.explodeContainer.add(sprite);

        sprite = this.scene.add.sprite(942, 623, 'falling_shield_02').setOrigin(0.5, 0.5);
        this.explodeContainer.add(sprite);
        
        sprite = this.scene.add.sprite(820, 625, 'falling_shield_01').setOrigin(0.5, 0.5);
        this.explodeContainer.add(sprite);

        this.enemy_impact_dust_back = this.scene.add.sprite(this.enemies.x, this.enemies.y, 'enemy_impact_dust_back').setOrigin(0.5, 0.5);
        this.bonusContainer.add(this.enemy_impact_dust_back);

        var config = {
            key: 'enemy_impact_dust_back',
            frames: this.scene.anims.generateFrameNumbers('enemy_impact_dust_back',
            {
                start: 0,
                end: 9,
            }),
            frameRate: 10,
            yoyo: false,
            repeat: 0
        };
    
        this.scene.anims.create(config);
        this.enemy_impact_dust_back.anims.load('enemy_impact_dust_back');

        this.enemy_impact_dust_front.anims.play('enemy_impact_dust_back');
        this.enemy_impact_dust_back.anims.play('enemy_impact_dust_front');
    }

    playBonusText() {
        this.scene.showWinning('BONUS', () => {
            this.reset();
        });
    }

    doCallback() {
        if(this.callback) {
            this.callback();
        }

        this.callback = undefined;
    }
}